export default __webpack_public_path__ + "static/media/bnb.d8c61230.svg";